// @flow
import React, { useContext } from 'react';

import { type LineProps } from 'Client/cms/toolkit/product-price-ticket-custom/productPriceTicketCustom.resolver';
import { getProductBadgeIcon } from 'Components/utils/product/product.utils';
import { PriceTicketContentWrapper } from 'Components/widgets/price-ticket/PriceTicketContentWrapper';
import { getPriceTicketSubtitle } from 'Components/widgets/price-ticket/priceTicket.mapper';
import { COLORS } from 'Components/utils/color/colors';
import { ReactPageContext } from 'Context/pageContext';
import { addTranslationKeys } from 'Src/i18n';
import { formatAmountForLocale } from 'Utils/currency-config-for-locale/currencyConfigForLocale';
import ReactAppContext from 'Context/ReactAppContext';

export const ProductPriceTicketCustom = (props: LineProps) => {
  const { pageType } = useContext(ReactPageContext);
  const { locale } = useContext(ReactAppContext);

  const { getAQuoteCTA, getAQuoteURL, price, amount, resort, config } = props;

  addTranslationKeys({
    ...config,
    productPriceTicketMiceLine: { getAQuoteCTA, getAQuoteURL, price, amount },
  });

  // Replace comma because users can use either 1234,56 or 1234.56 format
  const amountAsNumber = Number(amount.replace(/,/g, '.'));

  const staticPrice =
    price && amount && !Number.isNaN(amountAsNumber)
      ? {
          price,
          amount: formatAmountForLocale(amountAsNumber, locale),
        }
      : undefined;

  const priceTicketContentProps = {
    title: resort.name,
    subtitle: getPriceTicketSubtitle(resort),
    badgeIcon: getProductBadgeIcon(resort),
    button: {
      children: getAQuoteCTA,
      colorBg: COLORS.BOOKING,
      colorBorder: COLORS.BOOKING,
      url: getAQuoteURL,
      trackingData: {
        actionGA: 'priceBar',
        labelGA: 'getAQuote',
        categoryGA: pageType,
      },
    },
    staticPrice,
  };

  return (
    <div className="Line Line-PriceTicketCustom">
      <PriceTicketContentWrapper {...priceTicketContentProps} />
    </div>
  );
};
